<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="receipt icon"></i>
      {{ $t("billing") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/fel_gt.jpg" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <div
          class="ui form"
          ref="form"
          v-bind:class="{ loading: is_save_loading }"
        >
          <div class="ui grid">
            <div class="eight wide column">
              <h5 class="ui dividing header">{{ $t("issuer") }}</h5>
              <div class="field">
                <label for="">{{ $t("template") }}</label>
                <div class="ui selection dropdown" ref="template_dropdown">
                  <input type="hidden" name="template" />
                  <i class="dropdown icon"></i>
                  <div class="default text"></div>
                  <div class="menu"></div>
                </div>
              </div>
              <div class="ui list" v-if="issuer_data">
                <div class="item">
                  <i class="user icon"></i>
                  <div class="content">
                    <strong>{{ $t("name") }}</strong> {{ issuer_data.name }}
                  </div>
                </div>
                <div class="item">
                  <i class="id badge icon"></i>
                  <div class="content">
                    <strong>{{ $t("nit") }}</strong> {{ issuer_data.nit }}
                  </div>
                </div>
              </div>
            </div>
            <div class="eight wide column">
              <h5 class="ui dividing header">{{ $t("receiver") }}</h5>
              <div class="fields">
                <div class="six wide field">
                  <label for="">{{ $t("nit") }}</label>
                  <div class="ui action input">
                    <input type="text" name="nit" v-model="receiver.nit" />
                    <button
                      class="ui blue icon button"
                      v-bind:class="{
                        loading: loading_nit_search,
                        disabled:
                          !search_nit_enabled ||
                          (issuer_data && !issuer_data.id),
                      }"
                      @click="search_nit"
                    >
                      <i class="search icon"></i>
                    </button>
                  </div>
                </div>
                <div class="ten wide field">
                  <label for="">{{ $t("name") }}</label>
                  <input type="text" name="name" v-model="receiver.name" />
                </div>
              </div>
              <div class="field">
                <label for="">{{ $t("email") }}</label>
                <input type="text" name="email" v-model="receiver.email" />
              </div>
              <div class="fields">
                <div class="twelve wide field">
                  <label for="">{{ $t("address") }}</label>
                  <input
                    type="text"
                    name="address"
                    v-model="receiver.address"
                  />
                </div>
                <div class="four wide field">
                  <label for="">{{ $t("zip code") }}</label>
                  <input
                    type="text"
                    name="zip_code"
                    v-model="receiver.zip_code"
                  />
                </div>
              </div>
              <div class="three fields">
                <div class="field">
                  <label for="">{{ $t("country") }}</label>
                  <input
                    type="text"
                    name="country"
                    v-model="receiver.country"
                  />
                </div>
                <div class="field">
                  <label for="">{{ $t("department") }}</label>
                  <input
                    type="text"
                    name="department"
                    v-model="receiver.department"
                  />
                </div>
                <div class="field">
                  <label for="">{{ $t("municipality") }}</label>
                  <input
                    type="text"
                    name="municipality"
                    v-model="receiver.municipality"
                  />
                </div>
              </div>
            </div>
          </div>

          <generic-container
            :title="$t('items')"
            icon="list"
            :show_plus="true"
            @add="add_item"
            style="width: 100%"
          >
            <div class="row" v-for="(itm, idx) in items" :key="idx">
              <div class="fields" style="margin-bottom: 5px">
                <div class="two wide field">
                  <label for="" v-if="idx == 0">{{ $t("quantity") }}</label>
                  <input type="text" v-model="items[idx].quantity" />
                </div>
                <div class="three wide field">
                  <label for="" v-if="idx == 0">{{ $t("sale price") }}</label>
                  <input type="text" v-model="items[idx].sale_price" />
                </div>
                <div class="five wide field">
                  <label for="" v-if="idx == 0"> {{ $t("prod. name") }}</label>
                  <input type="text" v-model="items[idx].product_name" />
                </div>
                <div class="three wide field">
                  <label for="" v-if="idx == 0">{{
                    $t("disc. percen.")
                  }}</label>
                  <input type="text" v-model="items[idx].discount_percentage" />
                </div>
                <div class="three wide field">
                  <label for="" v-if="idx == 0">{{
                    $t("asset or service")
                  }}</label>
                  <input type="text" v-model="items[idx].asset_or_service" />
                </div>
                <div class="three wide field">
                  <label for="" v-if="idx == 0">{{
                    $t("meassur. unit")
                  }}</label>
                  <input type="text" v-model="items[idx].meassurement_unit" />
                </div>
                <div class="three wide field">
                  <label for="" v-if="idx == 0">{{ $t("tax. unit") }}</label>
                  <input type="text" v-model="items[idx].taxableUnit" />
                </div>
                <div class="field">
                  <label for="" v-if="idx == 0">{{ $t("opts.") }}</label>
                  <div class="ui red icon button" @click="remove_item(idx)">
                    <i class="trash icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <!-- <pre>{{ items }}</pre> -->
          </generic-container>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div
        class="ui green icon right labeled button"
        @click="save"
        v-bind:class="{ loading: is_save_loading, disabled: is_save_loading }"
      >
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api } from "@/utils";
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";
import { error_toast } from "../../../utils";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "FelGtBillingModalIndex",
  filters: filters,
  components: {
    GenericContainer,
  },
  computed: {},
  data() {
    return {
      emitters: [],
      selected_template: "",
      receiver: {
        nit: "",
        email: "",
        name: "",
        address: "",
        zip_code: "",
        country: "",
        department: "",
        municipality: "",
        // nit: "39521079",
        // email: "strato0100@gmail.com",
        // name: "Luis Robledo",
        // address: "San Pedro la Laguna, Atitlán",
        // zip_code: "01001",
        // country: "GT",
        // department: "Guatemala",
        // municipality: "Guatemala",
      },
      items: [],
      form: undefined,
      issuer_data: undefined,
      loading_nit_search: false,
      search_nit_enabled: false,
      is_save_loading: false,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /** Get emitters */
      local_api(vm, "post", "/fel_guatemala/emitter/do-get-list", {})
        .then((emitters) => {
          if (emitters) {
            // let stp = JSON.parse(r.setup);
            vm.emitters = emitters;
          }
        })
        .catch((err) => {
          error_toast(err);
        });

      /**
       * get template
       */
      if (data) {
        console.log(data);
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            // console.log(vm.emitters);
            let vls = vm.emitters.map((t) => {
              return { name: t.name, value: t.uuid };
            });
            window
              .jQuery(vm.$refs.template_dropdown)
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange(value) {
                  vm.selected_template = value;
                  let trgtSetting = vm.emitters.find((t) => {
                    return t.uuid == value;
                  });
                  if (trgtSetting) {
                    // console.log(trgtSetting);
                    vm.issuer_data = {
                      name: trgtSetting.setup.issuer_name,
                      nit: trgtSetting.setup.issuer_nit,
                      id: trgtSetting.id,
                    };

                    if (
                      !vm.receiver.nit &&
                      trgtSetting.setup.default_receiver_nit
                    )
                      vm.receiver.nit = trgtSetting.setup.default_receiver_nit;
                    if (
                      !vm.receiver.email &&
                      trgtSetting.setup.default_receiver_email
                    )
                      vm.receiver.email =
                        trgtSetting.setup.default_receiver_email;
                    if (
                      !vm.receiver.name &&
                      trgtSetting.setup.default_receiver_name
                    )
                      vm.receiver.name =
                        trgtSetting.setup.default_receiver_name;
                    if (
                      !vm.receiver.address &&
                      trgtSetting.setup.default_receiver_address
                    )
                      vm.receiver.address =
                        trgtSetting.setup.default_receiver_address;
                    if (
                      !vm.receiver.zip_code &&
                      trgtSetting.setup.default_receiver_zip_code
                    )
                      vm.receiver.zip_code =
                        trgtSetting.setup.default_receiver_zip_code;
                    if (
                      !vm.receiver.country &&
                      trgtSetting.setup.default_receiver_country
                    )
                      vm.receiver.country =
                        trgtSetting.setup.default_receiver_country;
                    if (
                      !vm.receiver.department &&
                      trgtSetting.setup.default_receiver_department
                    )
                      vm.receiver.department =
                        trgtSetting.setup.default_receiver_department;
                    if (
                      !vm.receiver.municipality &&
                      trgtSetting.setup.default_receiver_municipality
                    )
                      vm.receiver.municipality =
                        trgtSetting.setup.default_receiver_municipality;

                    /** Enable or disable search nit button */
                    let allowedSearchNitProviders = ["megaprint"];
                    let isAllowed = allowedSearchNitProviders.find((p) => {
                      return p == trgtSetting.provider;
                    });
                    vm.search_nit_enabled = isAllowed ? true : false;
                  }
                },
              });
          },
          onHide() {
            vm.form.form("reset");
            vm.items = [];
            vm.receiver.nit = "";
            vm.receiver.email = "";
            vm.receiver.name = "";
            vm.receiver.address = "";
            vm.receiver.zip_code = "";
            vm.receiver.country = "";
            vm.receiver.department = "";
            vm.receiver.municipality = "";
            vm.issuer_data = undefined;
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          nit: ["empty"],
          name: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        vm.is_save_loading = true;
        local_api(vm, "post", "/fel_guatemala/billing/do-create", {
          t: vm.selected_template,
          r: vm.receiver,
          i: vm.items,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            vm.form.form("add errors", [err]);
            error_toast(err);
          })
          .finally(() => {
            vm.is_save_loading = false;
          });
      }
    },
    add_item() {
      this.items.push({
        quantity: 1,
        sale_price: 1,
        product_name: "PRODUCTO 1",
        discount_percentage: "0",
        asset_or_service: "S",
        meassurement_unit: "UNI",
        taxableUnit: "1",
      });
    },
    search_nit() {
      let vm = this;
      vm.loading_nit_search = true;

      local_api(vm, "post", "/fel_guatemala/do-search-nit", {
        n: vm.receiver.nit,
        i: vm.issuer_data.id,
      })
        .then((r) => {
          if (r) {
            if (r.name) vm.receiver.name = r.name;
            if (r.address) vm.receiver.address = r.address;
          }
        })
        .catch((err) => {
          vm.receiver.name = "";
          vm.receiver.address = "";
          if (err.error && err.error.error) error_toast(err.error.error);
          else error_toast(err);
        })
        .finally(() => {
          vm.loading_nit_search = false;
        });
    },
    remove_item(idx) {
      let vm = this;
      vm.items.splice(idx, 1);
    },
  },
  mounted() {
    let vm = this;

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        template: ["empty"],
        nit: ["empty"],
        name: ["empty"],
      },
    });
    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
  watch: {},
  updated: function () {},
};
</script>
